module.exports = __webpack_public_path__ + "img/bj31.75a15d9f.png";